import React, { ReactNode } from 'react';
// import PerfectScrollbar from 'react-perfect-scrollbar';
import CustomScrollbar from 'react-scrollbars-custom';
import MainHeader from './main/MainHeader';
import Sidebar from './Sidebar';
import { makeStyles, createStyles, Theme, useTheme, useMediaQuery } from '@material-ui/core';

interface ComponentProps {
  children?: ReactNode;
  backgroundColor?: string;
  paddingTop?: number;
  onlyMobileView?: boolean;
}

const BasicLayout = React.memo((props: ComponentProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}
      style={{
        backgroundColor: props.backgroundColor ? props.backgroundColor : '#fff',
        paddingTop: props.paddingTop || props.paddingTop === 0 ? props.paddingTop : 16
      }}
    >
      <div className={classes.appBarSpacer}></div>
      <MainHeader handleDrawerOpen={handleDrawerOpen} />
      <Sidebar open={open} handleDrawerClose={handleDrawerClose} />
      {
        matchesSM || props.onlyMobileView
          ?
          <div className={classes.mainContainer}>
            {props.children}
          </div>
          :
          <div className={classes.mainContainer}>
            <CustomScrollbar >
              {props.children}
            </CustomScrollbar>
          </div>
      }
    </div >);
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
    },
    appBarSpacer: {
      ...theme.mixins.toolbar,
      minHeight: 64,
      marginBottom: theme.spacing(0),
      [theme.breakpoints.down('xs')]: {
        marginBottom: theme.spacing(0),
      },
    },
    mainContainer: {
      width: '100vw',
      height: '100%',
    },
    mainToolbar: {
      position: 'fixed',
      zIndex: 1,
      top: 64,
      //  backgroundColor: matchesSM ? '#fff' : 'transparent',
    },
    paper: {
      padding: 16,
      height: '96%'
    }
  }),
);

export default BasicLayout;
